import React from 'react';
//import uuidv4 from 'uuid';

import PropTypes from 'prop-types';
//import update from 'immutability-helper';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

//comopnents:
import NeuriteGrid from '../../neurite_grid';

//helpers:
import { getData } from '../../../dataLib';

const styles = theme => ({
    root: {
        // height: '100%',
        // width: 240
        flexGrow: 1,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 700,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        //margin: '5px 25px',
        minWidth: 120,
        //height: 72,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
});

class EditListaAlbaran extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pedido_id: this.props.pedido.id,
            centro_id: this.props.pedido.centroId,
            centroDescr: this.props.centroDescr,
            proveedorDescr: this.props.pedido.proveedorDescr,
            fDoc: this.props.pedido.fDoc,
            documento: this.props.pedido.refPedido,
            obsv: this.props.pedido.obsv,
            showSpinner: true,
            albaranes: [],
        };
    }

    componentDidMount() {
        // obtiene lista de líneas de albarán para un pedido
        let URL = 'DCAlbarans/lista_alb?pedido_id=' + this.props.pedido.id;

        this.setState({ ...this.state, showSpinner: true });
        getData(
            URL,
            response => {
                this.setState({
                    ...this.state,
                    albaranes: response.data.map(p => {
                        return {
                            ...p,
                            ft_fEntrega: p.fEntrega ? new Date(p.fEntrega).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' }) : '',
                        }
                    }),

                    showSpinner: false,
                });
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching lista albaranes',
                    },
                    'edit_lista_albaran',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    }


    render() {
        const { classes } = this.props;

        if (this.state.showSpinner === true)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress
                        className={classes.spinner}
                        color="primary"
                    />
                </div>
            );
        else {
            return (
                <div className={classes.root}>
                    <div style={{ marginBottom: 20 }}>
                        <div className={classes.margin} containerPair>
                            <Typography
                                variant="h6"
                                className={classes.title}
                                color={'primary'}
                            >
                                {'Centro: ' + this.props.centroDescr}
                            </Typography>
                        </div>
                        <div className={classes.containerPair}>
                            <Typography
                                variant="body1"
                                className={classes.title}
                                color={'secondary'}
                            >
                                {'Fecha pedido: ' +
                                    this.props.pedido.fDoc.slice(0, 10)}
                            </Typography>
                            <Typography
                                variant="body2"
                                className={classes.title}
                                color={'secondary'}
                            >
                                {'Proveedor: ' +
                                    this.props.pedido.proveedorDescr}
                            </Typography>
                        </div>
                        <div className={classes.containerPair}>
                            <Typography
                                variant="body1"
                                className={classes.title}
                                color={'secondary'}
                            >
                                {'Documento: ' + this.props.pedido.refPedido}
                            </Typography>
                            <Typography
                                variant="body2"
                                className={classes.title}
                                color={'secondary'}
                            >
                                {'Obsv: ' + this.props.pedido.obsv}
                            </Typography>
                        </div>
                    </div>
                    <div>
                        <div className={classes.margin}>
                            <Typography
                                variant="h6"
                                className={classes.title}
                                color={'primary'}
                            >
                                Albaranes
                            </Typography>
                        </div>
                    </div>

                    <div style={{ marginBottom: 20 }}>
                        {this.state.albaranes ? (
                            <NeuriteGrid
                                id="e_l_a"
                                columns={[
                                    {
                                        key: 'ft_fEntrega',
                                        name: 'Fecha entrega',
                                        editable: false,
                                        dragable: false,
                                        width: 90,
                                    },
                                    {
                                        key: 'refAlbaran',
                                        name: 'Ref. Albaran',
                                        editable: false,
                                        dragable: false,
                                        width: 100,
                                    },
                                    {
                                        key: 'articuloDescr',
                                        name: 'Artículo',
                                        editable: false,
                                        dragable: false,
                                        width: 300,
                                    },
                                    {
                                        key: 'cantidad',
                                        name: 'Ud.Recib.',
                                        tooltip: 'Número de unidades recibidas',
                                        editable: true,
                                        dragable: false,
                                        type: 'int',
                                        width: 60,
                                    },
                                ]}
                                rows={this.state.albaranes}
                                height={500}
                                buttonEdit={false}
                                buttonDelete={false}
                                buttonNew={false}
                            />
                        ) : (
                                ''
                            )}
                    </div>

                    <div className={classes.buttonsContainer}>
                        <Button
                            className={classes.buttonsBottom}
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.hideDialog()}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            );
        }
    }
}

EditListaAlbaran.propTypes = {
    pedido: PropTypes.object.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditListaAlbaran);
